export const normalizeTicketText = (value: unknown): string => {
  if (typeof value !== "string" && typeof value !== "number") {
    return "";
  }

  return String(value).trim().toLowerCase();
};

const isTicketLikeRecord = (value: unknown): value is Record<string, unknown> => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  const record = value as Record<string, unknown>;
  const ticketNumber =
    record.ticketNumber ??
    record.ticketnumber ??
    record.ticketId ??
    record.incidentid;
  const targetSystem = record.targetSystem ?? record.source ?? record.platform;
  const status = record.status ?? record.statecode ?? record.statuscode;

  return (
    normalizeTicketText(ticketNumber) !== "" &&
    (normalizeTicketText(targetSystem) !== "" ||
      normalizeTicketText(status) !== "")
  );
};

export const getCachedTicketArray = (cachedValue: unknown): any[] => {
  const candidate = Array.isArray(cachedValue)
    ? cachedValue
    : Array.isArray((cachedValue as any)?.data)
      ? (cachedValue as any).data
      : [];

  return candidate.filter(isTicketLikeRecord);
};

// Generated by Copilot
// updated on: 2026-10-01 | 39 lines added | [Auto Generated] | Added safe ticket text and cache validation helpers | Time Taken 3 min
